import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { TenantDefault, UpdateTenantDefault } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { createTenantDefaultApi, tenantDefaultKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateTenantDefaults(): UseMutationResult<TenantDefault, Error, UpdateTenantDefault> {
  const client = useApiClient('admin-auth');
  const api = createTenantDefaultApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<TenantDefault, Error, UpdateTenantDefault>({
    mutationFn: (data: UpdateTenantDefault) => api.updateTenantDefaults(data),
    onError: () => {
      toast.error(t('tenantDefaults.toast.updateError'));
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: tenantDefaultKeys.detail() });
      toast.success(t('tenantDefaults.toast.updated'));
    },
  });
}
